export enum types {
  UPDATE_FORMDATA = 'UPDATE_FORMDATA',
  OPEN_VIDEO = 'OPEN_VIDEO',
  OPEN_TAG = 'OPEN_TAG',
  OPEN_PERSON = 'OPEN_PERSON',
  OPEN_ATTACHMENTS = 'OPEN_ATTACHMENTS',
  OPEN_COMMENTQUESTION = 'OPEN_COMMENTQUESTION',
  OPEN_WEEKS = 'OPEN_WEEKS',
  OPEN_IMAGES = 'OPEN_IMAGES',
}
